import React from "react";

const RewardsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 19.375C4.83063 19.375 0.625 15.1694 0.625 10C0.625 4.83063 4.83063 0.625 10 0.625C15.1694 0.625 19.375 4.83063 19.375 10C19.375 15.1694 15.1694 19.375 10 19.375ZM10 1.875C5.52 1.875 1.875 5.52 1.875 10C1.875 14.48 5.52 18.125 10 18.125C14.48 18.125 18.125 14.48 18.125 10C18.125 5.52 14.48 1.875 10 1.875Z"
        fill="currentColor"
      />
      <path
        d="M13.246 15.0925C13.1553 15.0925 13.0644 15.0728 12.9794 15.0328L9.9997 13.629L7.02001 15.0328C6.81376 15.1303 6.57064 15.1072 6.38626 14.9731C6.20189 14.839 6.10501 14.615 6.13376 14.3887L6.54845 11.1212L4.29251 8.72124C4.13626 8.55499 4.08314 8.31717 4.15345 8.09999C4.22407 7.88311 4.4072 7.72186 4.63126 7.67905L7.86689 7.06374L9.4522 4.17655C9.56189 3.97655 9.77189 3.85217 10 3.85217C10.2281 3.85217 10.4381 3.97624 10.5478 4.17655L12.1331 7.06374L15.3688 7.67905C15.5928 7.72155 15.776 7.88311 15.8466 8.09999C15.9169 8.31686 15.8638 8.55499 15.7075 8.72124L13.4516 11.1212L13.8663 14.3887C13.895 14.615 13.7981 14.839 13.6138 14.9731C13.505 15.0519 13.3756 15.0925 13.246 15.0925ZM10 12.3131C10.0913 12.3131 10.1822 12.3328 10.2666 12.3728L12.4828 13.4169L12.1744 10.9865C12.151 10.8015 12.2113 10.6156 12.3391 10.4797L14.0172 8.69467L11.6103 8.23686C11.4272 8.20186 11.2691 8.08717 11.1794 7.92374L10.0003 5.77624L8.82126 7.92374C8.73158 8.08717 8.57345 8.20217 8.39033 8.23686L5.98345 8.69467L7.66158 10.4797C7.78939 10.6156 7.8497 10.8012 7.82626 10.9865L7.51783 13.4169L9.73408 12.3728C9.81845 12.3331 9.90939 12.3131 10.0006 12.3131H10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RewardsIcon;
